import React, { FC } from 'react'
import { Box, ScreenReaderOnly, TextBody } from '@ally/metronome-ui'

export interface WiresNotifcationsProps {
  wiresNotificationFFValue: string
}

export const WiresNotification: FC<WiresNotifcationsProps> = ({
  wiresNotificationFFValue,
}) => {
  switch (wiresNotificationFFValue) {
    case 'stageOne':
      return (
        <Box mb="md">
          <TextBody tag="p" size="sm">
            We&apos;re making some updates that will temporarily affect your
            ability to send future-dated wires. Starting Jan. 16, you can&apos;t
            schedule wires to send after Feb. 13. You&apos;ll still be able to
            request same-day wires.
          </TextBody>
        </Box>
      )
    case 'stageTwo':
      return (
        <Box mb="md">
          <TextBody tag="p" size="sm">
            We&apos;re making some updates that will temporarily affect your
            ability to send future-dated wires. You can&apos;t schedule wires to
            send after Feb. 13, but you&apos;ll still be able to request
            same-day wires. Note: On Feb. 13, we&apos;ll also need to review all
            wire requests by 12 pm ET (normally 3 pm ET) for same-day delivery.
          </TextBody>
          <ScreenReaderOnly as="p">
            We&apos;re making some updates that will temporarily affect your
            ability to send future-dated wires. You can&apos;t schedule wires to
            send after Feb. 13, but you&apos;ll still be able to request
            same-day wires. Note: On Feb. 13, we&apos;ll also need to review all
            wire requests by 12 pm eastern time (normally 3 pm eastern time) for
            same-day delivery.
          </ScreenReaderOnly>
        </Box>
      )
    case 'stageThree':
      return (
        <Box mb="md">
          <Box aria-hidden>
            <TextBody tag="p" size="sm">
              Our wire transfer service will be unavailable beginning at 12 pm
              ET for tech maintenance. We&apos;ll process same-day transfer
              requests we review by 12 pm ET. Everything should be back up and
              running tomorrow morning.
            </TextBody>
          </Box>
          <ScreenReaderOnly as="p">
            Our wire transfer service will be unavailable beginning at 12 pm
            eastern time for tech maintenance. We&apos;ll process same-day
            transfer requests we review by 12 pm eastern time. Everything should
            be back up and running tomorrow morning.
          </ScreenReaderOnly>
        </Box>
      )
    default:
      return null
  }
}
